module.exports = __webpack_public_path__ + "img/help.efa52f78.jpeg";